export default "__VITE_PUBLIC_ASSET__b0b27812__"